module.exports = __webpack_public_path__ + "static/media/availability.de21af6e.svg";